<template>
  <!-- 教师端-隐私政策及权限说明 -->
  <div class="privacy">
    <p>本政策仅适用于江西风向标智能科技有限公司的知心慧学教师端产品。</p>
    <div class="update">
      <p>更新日期：2025年7月31日</p>
      <p>生效日期：2025年7月31日</p>
    </div>
    <h2>隐私政策及权限说明</h2>
    <p class="bold">知心慧学教师端App采用严格的数据安全措施保护您的隐私安全。</p>
    <p class="bold">您选择【同意并开始使用】即表示您已充分阅读、理解和接受
      <a href="javascript:;" class="blue" @click="clickPrivacy(1)">《用户服务协议》</a>和<a href="javascript:;" class="blue"
        @click="clickPrivacy(2)">《隐私政策》</a>。
      您也可以选择【不同意并退出】，知心慧学教师端App将无法为您提供产品或服务。
    </p>

      <p class="bold">
        知心慧学教师端app使用许可2.2&知心慧学教师端隐私政策2.2
      </p>
      <p>
        以下内容是《知心慧学教师端app使用许可2.2》及《知心慧学教师端隐私政策2.2》，在你登录注册知心慧学教师端前请务必审慎阅读、充分理解协议中相关条款内容。《知心慧学教师端app使用许可2.2》包括app使用许可；信息使用；风险提示；知识产权。《知心慧学教师端隐私政策2.2》包括适用范围；我们收集信息的原因和内容；我们会如何使用您的信息；我们可能如何收集信息；我们会如何共享、转让、公开披露您的个人信息；如何管理您的个人信息；推广服务；我们会如何保护和保存您的个人信息；第三方提供商及其服务；本政策如何更新及适用范围；联系我们。你一旦登录注册知心慧学教师端，即视为你已了解并同意《知心慧学教师端app使用许可2.2》及《知心慧学教师端隐私政策2.2》的各项内容。
      </p>
      <p>
        在此特别提醒您，在点击接受本声明之前，您应事先认真阅读、了解清楚并充分理解本声明的全部内容，包括免除或者限制责任的免责条款及对您的权利限制条款。请您审阅并接受或不接受本声明（未成年人应在法定监护人陪同下审阅）。
        除非您接受本声明，否则您无权下载、安装或使用本公司基于应用软件提供的相关服务（以下称"服务"）。一旦您点击确认本声明，即意味着您已充分理解和接受本声明，并同意接受本声明各项条款的约束。并且，公司在法律许可的范围内享有对本声明的解释、修改以及变更的权利。
      </p>
      <p class="bold">
        知心慧学教师端app使用许可2.2
      </p>
      <p>
        一、APP使用许可
      </p>
      <p>
        1.您使用的“知心慧学教师端”（以下简称“APP”）是由江西风向标智能科技有限公司（以下简称“公司”）运营的在线教育增值服务平台。
      </p>
      <p>
        2.“知心慧学教师端用户”是指完成全部注册流程，愿意接受本协议并在知心慧学教师端相关使用规范的规定下使用知心慧学教师端APP服务的注册用户。
      </p>
      <p>
        3.注册成为本APP之用户或使用本APP，即表示您保证您已具备单独签订本协议并遵守本协议所有条款之民事权利能力及民事行为能力。 </p>
      <p>
        4.您郑重承诺，将以本人真实的身份，秉承诚实信用合法的原则使用本APP，在登录和使用本APP的全过程中都负有作为理性人的谨慎和注意义务。 </p>
      <p>
        5.本公司保留对APP使用规定的解释、修改以及变更的权利，届时将通过APP通告等方式向用户传达，如果不同意对本协议相关条款所做的修改，用户有权停止使用网络服务。如果用户继续使用网络服务，则视为用户接受本协议相关条款所做的修改。如您未在通知规定的时间内表示反对，将会被视为默认。
      </p>
      <p>
        二、信息使用
      </p>
      <p class="key-msg">
        1.在注册、登陆和使用知心慧学教师端APP时，您同意及不可撤销地授权将您的姓名和账户等信息提供给我们，包括但不限于您的真实姓名、联系方式、身份证号码、住址、账号信息等。
      </p>
      <p>
        2.您在使用知心慧学教师端时，承诺和保证如下内容：
      </p>
      <p>
        (a)您所提供的资料为完整，最新及正确无误；
      </p>
      <p>
        (b)本协议一经签署，即具法律效力并同意受其约束。
      </p>
      <p>
        3.您的注册信息包括注册号和密码仅供本人使用，您有义务提高自我保护和防范风险意识，如提高密码级别、不随意向其他人透露您的用户名、口令等信息。如若由于您个人对账号信息保管不慎或告知他人而导致任何个人信息泄露、账户损失等，知心慧学教师端将不予承担任何责任。
      </p>
      <p class="key-msg">
        4.我们将对您所提供的资料进行严格的管理及保护，致力于保护用户个人数据及个人隐私安全，原则上不提供给任何个人或者第三方使用，拒绝任何组织和个人以营利为目的意图获取或者使用用户个人信息。特殊情况如司法机关、监管机构或其他政府部门依照法定程序要求提供用户个人信息等为例外。本APP在必要时将会由专业技术人员代为对您相关信息资料进行处理，以符合专业分工的要求。
      </p>
      <p>
        如发生下列任何一种情形，本APP有权随时使用用户提交信息资料、中断或终止向用户提供本协议项下的网络服务而无需通知用户：
      </p>
      <p>
        (a)用户提供的个人资料不真实；
      </p>
      <p>
        (b)用户违反本协议中规定的使用规则；
      </p>
      <p>
        (c)为免除您在生命、身体或财产方面之急迫危险的；
      </p>
      <p>
        (d)为防止他人权益之重大危害的；
      </p>
      <p>
        (e)为增进公共利益，且无害于您的重大利益的。除前款所述情形外，本APP同时保留在不事先通知用户的情况下随时中断或终止部分或全部网络服务的权利，对于所有服务的中断或终止而造成的任何损失，本APP无需对用户或任何第三方承担任何责任。
      </p>
      <p>
        三、风险提示
      </p>
      <p>
        1.对在任何情况下因使用或不能使用本APP所产生的直接、间接、偶然、特殊及后续的损害及风险，我们不承担任何责任。损失包括但不限于决策对于由此给您造成的任何不便或损害，包括但不限于：决策失误、操作不当、遗忘或泄露账户密码、密码被他人破解、您使用的终端设备被第三方侵入而造成的损失。
      </p>
      <p>
        2.您于订立协议时已表示理解并同意免除我们与此相应的法律责任。如在本APP运营过程中出现我们误将您的账户终止，或变更您的有关信息，或部分停止您的各类权限，则我们将在您提出书面通知后合理期间内处理该等事宜，若因此给您带来不便甚至造成损失，您同意免除我们的相应法律责任。
      </p>
      <p>
        3.您了解并同意，我们不对因下述任一情况而导致的任何损害赔偿承担责任： (a)使用或未能使用本APP服务； (b)对本APP服务的错误理解； (c)第三方未使用真实身份，或者未经批准的使用他人的账号或更改他人的数据；
        (d)任何非因本APP的原因而引起的与服务有关的损失。
      </p>
      <p>
        4.对于任何本APP无法控制的原因（包括但不限于政府管制、通讯设施故障及其他不可抗力因素）导致的APP暂时关闭、用户信息泄露、被盗用、被篡改等非正常经营行为，本APP不承担任何责任。
      </p>
      <p>
        5.您承认对于您利用本APP或信息而从事的各类行为，包括线上和线下，均为您个人行为且您个人对该类行为承担完全责任。您同意保障和维护APP及其他用户的利益，如因违反有关法律、法规或本协议项下的任何条款而给本APP或任何其他第三人造成损失，您同意承担由此造成的损害赔偿责任。
      </p>
      <p>
        6.由于您将用户密码告知他人或与他人共享注册账户，由此导致的任何个人信息的泄露，任何由于黑客攻击、计算机病毒侵入或发作、因政府管制而造成的暂时性关闭等影响网络正常经营之不可抗力而造成的个人信息泄露、丢失、被盗用或被篡改等，由于本APP不拥有或不控制的公司以及我们不雇佣或不管理的人员所造成的个人信息的泄露，本APP不承担任何责任并应免于被追诉。
      </p>
      <p>
        7.用户同意保障和维护知心慧学教师端APP及其他用户的利益，如因用户违反有关法律、
        法规或本协议项下的任何条款而给本APP或任何其他第三人造成损失，用户同意承担由此造成的损害赔偿责任。在注册成为本APP用户或者使用本APP过程中，您与任何第三方之间发生任何纠纷，由纠纷各方自行解决，本APP并不承担任何责任。本APP不对您使用本APP的任何行为、效果或影响提供任何担保或条件，无论是明示、默示或法定的。
      </p>
      <p>
        四、知识产权
      </p>
      <p>
        1.无论您成为本APP之会员或使用本APP，均认可我们对本APP及本APP所收集、制作、发布之各类信息拥有完全知识产权或所有权，包括但不限于各类文档、图像、数据库等，除非法律明确规定该等权利属于会员个人以外，相关权限应涵盖包括复制、修改、改写、改编、发行、翻译、创造衍生性著作、出版、将前述内容(部分或全部)加以散布、展示等。您同意我们对所有会员提交的信息进行有关编排处理后形成的数据库拥有完全的知识产权。
      </p>
      <p>
        2.如您将信息公布到本APP的任何公共区域，则表示您同意，同时您自动授予，并且您陈述并保证您有权授予本APP不可撤销的、永久的、非独占的、完全免费的、世界范围的许可。在该等许可下，您同意本APP使用、复制、执行、显示并传播该内容，您也同意我们基于该内容创作衍生作品或将该内容整合到其他作品中且我们对该等衍生作品或整合作品拥有完全的所有者权益。除已获得我们书面许可的情况外，您不得复制、修改、公布、传播、执行、转载、许可使用、创建衍生作品、转移显示、出售、转售、以非法手段获取或以任何其他方式处置本APP收集、制作、发布的各类信息。
      </p>
      <p>
        3.请勿擅自复制或采用本APP所创造的用以制成网页的HTML。本APP对其HTML享有著作权。同时，本APP对其网址上的所有图标、图饰、图表、色彩、文字表述及其组合、版面设计、数据库均享有完全的著作权，对发布的信息均享有专有的发布和使用权，未经本APP同意，不得擅自复制、使用或转载。
      </p>
      <p>
        &nbsp;
      </p>
      <p class="bold tac">
        知心慧学教师端隐私政策2.2
      </p>
      <p>
        &nbsp;
      </p>
      <p>
        本政策仅适用于江西风向标智能科技有限公司的知心慧学教师端产品。
      </p>
      <p>
        最新更新日期：2025年7月31日。
      </p>
      <p>
        如对本隐私政策或相关事宜有任何问题、建议、意见及咨询，您可随时通过发送邮件至 <span class="blue">legal@fxbjy.com</span>或拨打我们的客服电话<span
          class="blue">19970080755</span>等多种方式与我们联系，我们将在十五个工作日内受理并处理。
      </p>
      <p>
        &nbsp;
      </p>
      <p class="bold">
        本政策将帮助您了解以下内容：
      </p>
      <p>
        ·知心慧学教师端的个人信息收集使用规则
      </p>
      <p>
        ·我们如何保护您的个人信息
      </p>
      <p>
        ·您的权利
      </p>
      <p>
        ·我们会如何共享、转让、公开披露您的个人信息
      </p>
      <p>
        ·本政策如何更新
      </p>
      <p>
        ·如何联系我们
      </p>
      <p>
        【特别提示】请仔细阅读《知心慧学教师端隐私政策2.2》（尤其是加粗划线的内容）并确定了解我们（江西风向标智能科技有限公司）对您个人信息的处理规则。阅读过程中，如您有任何疑问，可联系我们的客服咨询，如果您不同意相关协议或其中任何条款约定，知心慧学教师端将暂时无法为您提供定制服务。本隐私政策与您所使用的知心慧学教师端服务以及该服务所包括的各种业务功能（以下统称“我们的产品与/或服务”）息息相关，希望您在使用我们的产品与/或服务前仔细阅读并确认您已经充分理解本政策所写明的内容，并让您可以按照本隐私政策的指引做出您认为适当的选择。本隐私政策中涉及的相关术语，我们尽量以简明扼要的表述，并提供进一步说明的链接，以便您更好地理解。您使用或在我们更新本隐私政策后（我们会及时提示您更新的情况）继续使用我们的产品与/或服务，即意味着您同意本隐私政策(含更新版本)内容，并且同意我们按照本隐私政策收集、使用、保存和共享您的相关信息。如对本隐私政策或相关事宜有任何问题，您可随时通过发送邮件至info@fxbjy.com
        或拨打我们的任何一部客服电话等多种方式与我们联系 。 </p>
      <p>
        一、 适用范围
      </p>
      <p>
        本隐私政策适用于知心慧学教师端。教师端提供的所有服务，您访问知心慧学教师端网站、客户端，均适用本隐私政策。 </p>
      <p>
        二、我们收集信息的原因和内容
      </p>
      <p>
        为了保障您能够流畅地使用我们的核心功能并向您提供更好、更优的服务，同时为了保障您的信息安全，我们将根据您使用的服务收集您的以下信息。
      </p>
      <p>
        1、您直接提供给我们的信息
      </p>
      <p>
        <span
          class="key-msg">当您注册时，您需要至少向我们提供您准备使用的知心慧学教师端账户名、密码、您本人的手机号码、电子邮箱地址（用于验证邮箱），我们将通过发送短信验证码或邮件的方式来验证您的身份是否有效。此时，您需要向我们提供以下信息：账号名称、头像（如有）和手机号码等。</span>提供上述信息并同意注册协议和本政策后，您可以使用知心慧学教师端的部分业务功能，包括：查看学生学情分析、组卷、阅卷、浏览知心慧学教师端平台内的内容等。<span
          class="key-msg">在您注册知心慧学教师端账号时，我们会使用手机号码对您任课的班级进行绑定，便于将您与其他用户区分并准确判断您的学习情况，为您提供考情报告信息。</span>如您拒绝提供手机号码或进行学情信息绑定，您仍可浏览部分知心慧学教师端平台内的内容，但将无法使用查看学生学情分析、组卷、阅卷等核心功能。
      </p>
      <p>
        2、在您使用过程中产生的信息
      </p>
      <p>
        当您使用知心慧学教师端的某些业务功能时，为满足向您提供该产品和服务之目的，<span class="key-msg">除注册信息外，
          您还需要进一步向我们提供包括但不限于您的个人身份信息及其他为您提供服务所必需的信息，同时，我们的产品集成友盟+SDK， 友盟+SDK需要收集您的设备Mac地址、唯一设备识别码 （IMEI/android
          ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息），收集这些信息的目的是提供统计分析服务，提供基础反作弊能力。</span>提供以上信息，将有助于我们给您提供更优的服务体验，如果您不提供这些信息，
        并不会影响您使用知心慧学教师端的基本功能。如果您不使用特定产品和服务，则无需提供相关信息（以下将详细阐明）。
      <p>
        我们可能对您的使用信息、浏览信息进行记录，用来为您展示历史使用、浏览记录。
      </p>
      <p>
        我们还可能为了提供服务及改进服务质量的合理需要而获得您的其他信息，包括您与客服联系时您提供的相关信息， 您参与问卷调查时向我们发送的问卷答复信息，以及您与我们的关联方、我们合作伙伴之间互动时我们获得的相关信息。
        对于您的账号个人设置信息，我们可能会将它们进行关联，以便我们能在您登录其他设备时为您提供一致的服务。 我们可能会将来自某项服务的信息与来自其他服务的信息结合起来，以便为您提供服务、定制内容和建议。
      </p>
      <p>
        3、征得授权同意的例外
      </p>
      <p>
        根据相关法律法规的规定，以下情形中收集您的个人信息无需征得您的授权同意：
      </p>
      <p>
        （1）涉及国家安全与利益、社会公共利益；
      </p>
      <p>
        （2）与犯罪侦查有关的相关活动；
      </p>
      <p>
        （3）出于维护您或他人的生命财产安全但在特殊情况下无法获得您的及时授权；
      </p>
      <p>
        （4）从其他合法公开的渠道中收集您的个人信息；
      </p>
      <p>
        （5）法律法规规定的其他情形。
      </p>
      <p>
        三、我们会如何使用您的信息
      </p>
      <p>
        收集您的信息是为了向您提供服务及提升服务质量，我们会根据本隐私政策的约定进行使用，在收集您的信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别主体。请您了解并同意，在此情况下我们有权使用已经去标识化的信息；并在不透露您个人信息的前提下，我们有权对用户数据库进行分析并予以合法使用。
      </p>
      <p class="key-msg">
        您的信息主要有以下用途：
      </p>
      <p class="key-msg">
        （1）为您提供您使用的各项定制服务，并维护、改进这些服务。
      </p>
      <p class="key-msg">
        （2）帮助我们设计新服务，提升现有服务体验。
      </p>
      <p class="key-msg">
        （3）在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性。
      </p>
      <p class="key-msg">
        （4）邀请您参与知心慧学教师端活动和市场调查。
      </p>
      <p class="key-msg">
        （5）开展内部审计、数据分析和研究，以更好地改善我们的产品、服务及与用户之间的沟通。
      </p>
      <p>
        四、我们可能如何收集信息
      </p>
      <p>
        1、您使用我们的服务时，我们会在您的计算机或移动设备上存储名为 Cookie 的小数据文件。Cookie
        通常包含标识符、站点名称以及一些号码和字符。我们使用该等信息判断注册用户是否已经登录，提升服务/产品质量及优化用户体验。如您不希望个人信息保存在 Cookie 中，您可对浏览器进行配置，选择禁用 Cookie 功能。禁用
        Cookie 功能后，可能影响您访问知心慧学教师端或不能充分取得知心慧学教师端提供的服务。
      </p>
      <p>
        知心慧学教师端不会将 Cookie 用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除Cookie。您可以清除计算机上保存的所有 Cookie，大部分网络浏览器都设有阻止 Cookie 的功能。
      </p>
      <p>
        2、设备权限调用
      </p>
      <p>
        <span
          class="key-msg">知心慧学教师端在提供服务的过程中，可能需要您开通一些设备权限，例如通知、相册、相机等访问权限。您也可以在设备的设置功能中随时选择关闭部分或者全部权限，从而拒绝知心慧学教师端收集相应的个人信息。</span>在不同设备中，权限显示方式及关闭方式可能有所不同，具体请参考设备及系统开发方说明或指引。
      </p>
      <p>
        根据您的服务使用情况，我们可能会调用的权限如下：
      </p>
      <p>
        （1）储存权限。当您下载及升级应用、试卷保存、阅卷信息保存、联系在线客服反馈问题时，我们会调用您的储存权限，保障您能顺利实现此功能。
      </p>
      <p>
        （2）摄像头权限。当您提交意见反馈、修改头像时，我们将调用您的摄像头权限，保障您的使用。
      </p>
      <p>
        （3）语音权限：当您使用知心慧学教师端直播课功能，或类似直播服务用于线上上课和发言时，我们将调用您设备的语音权限，以保证您能顺利实现此功能。
      </p>
      <p>
        （4）短信权限：当您注册账号时，我们将调用短信权限，保障您能顺利完成注册。
      </p>
      <p>
        五、我们会如何共享、转让、公开披露您的个人信息
      </p>
      <p>
        1、共享
      </p>
      <p>
        知心慧学教师端不会在未经您同意或授权的情况下将您的个人信息提供给第三方。但是，经您确认同意，知心慧学教师端可在以下情况下共享您的个人信息：
      </p>
      <p>
        在获取同意的情况下共享：获得您的明确同意后，知心慧学教师端会与其他方共享您的个人信息。
      </p>
      <p>
        共享给知心慧学教师端的关联公司：在本政策声明的使用目的范围内，您的个人信息可能会与知心慧学教师端的关联公司共享。作为一项政策，我们只会共享必要的信息。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。
      </p>
      <p>
        共享给授权合作伙伴：知心慧学教师端可能会与合作伙伴共享您的某些个人信息，以便给您提供服务、内容和建议。例如，知心慧学教师端向您寄送礼品（如有）时，知心慧学教师端必须与物流服务提供商共享您的个人信息才能安排寄送，或者安排合作伙伴向您提供服务。我们仅会出于特定、明确而合法的目的处理您的个人信息，并且只会共享提供服务所必要的信息。同时，我们会与其签署严格的保密协定，要求他们按照我们的说明、本政策以及其他任何相关的保密和安全措施来处理个人信息。在法定情形下的共享：我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。
      </p>
      <p class="key-msg">事先获得您明确同意的情况下，我们会在法律法规允许且不违背公序良俗的范围内，依据您的授权范围与第三方共享您的信息。</p>
      <p>为知心慧学教师端App相关功能的实现与应用安全稳定的运行，我们可能会接入由第三方提供的软件开发包（SDK）实现相关目的。 我们会对合作方获取信息的软件工具开发包（SDK）进行严格的安全监测，以保护数据安全。</p>
      <p>请注意，第三方SDK可能因为其版本升级、策略调整原因导致数据处理类型存在一定变化，请以其公示的官方说明为准。</p>
      <p>1.1 第三方SDK目录</p>
      <p>第三方SDK名称：微信 SDK</p>
      <p>所属公司名称：深圳市腾讯计算机系统有限公司</p>
      <p>收集个人信息类型：设备品牌、设备型号、设备版本、系统版本、生成ID、手机样式、手机名、iccid、bssid、MAC地址、IMSI、IMEI、IP地址、网络状态</p>
      <p>使用目的：授权登录、内容分享</p>
      <p>收集方式：sdk本机采集</p>
      <p>使用场景：微信授权登录、分享内容至微信</p>
      <p>第三方SDK隐私政策或开发指南：</p>
      <p><a
          href="https://developers.weixin.qq.com/doc/oplatform/Mobile_App/Share_and_Favorites/Share_and_Favorites.html">https://developers.weixin.qq.com/doc/oplatform/Mobile_App/Share_and_Favorites/Share_and_Favorites.html</a>
      </p>
      <p>第三方公司名称：友盟同欣（北京）科技有限公司</p>
      <p>产品/类型：友盟sdk</p>
      <p>收集个人信息类型：IMEI/OAID/MAC/Android ID /IDFA/OpenUDID/GUID/IP地址/SIM卡IMSI信息等）</p>
      <p>使用目的：云平台、企业协作、辅助运营</p>
      <p>收集方式：sdk本机采集</p>
      <p>功能：为成功调起您用户设备中应用，高效实现第三方登录和社会化分享功能，我们会收集系统在装的应用列表信息，提升您用户的使用体验</p>
      <p>第三方隐私权政策链接：</p>
      <p><a
          href="https://www.umeng.com/page/policy?spm=a211eg.10560647.0.0.eb2c34dcwKPqBz">https://www.umeng.com/page/policy?spm=a211eg.10560647.0.0.eb2c34dcwKPqBz</a>
      </p>
      <p>第三方公司名称：华为终端有限公司</p>
      <p>产品/类型：华为推送sdk</p>
      <p>收集个人信息类型：应用基本信息、设备标识信息（IMEI、Android ID、AAID和Push Token）、设备的硬件信息、系统基本信息和系统设置信息、应用安装列表信息、申请获取存储权限、电话权限</p>
      <p>使用目的：用于向华为手机用户推送消息</p>
      <p>收集方式：sdk本机采集</p>
      <p>使用场景：向用户推送消息时</p>
      <p>第三方隐私权政策链接：</p>
      <p><a
          href="https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177">https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177</a>
      </p>
      <p>第三方公司名称：小米公司</p>
      <p>产品/类型：小米推送sdk</p>
      <p>收集个人信息类型：设备标识信息(SSID、OAID、加密的Android ID)、推送消息内容、设备信息(设备厂商、型号、归属地、运营商名称等)、通知栏设置、运营商信息、申请获取存储权限、位置权限</p>
      <p>使用目的：用于向小米用户推送消息</p>
      <p>收集方式：sdk本机采集</p>
      <p>使用场景：向用户推送消息时</p>
      <p>第三方隐私权政策链接：</p>
      <p><a href="https://dev.mi.com/console/doc/detail?pId=1822">https://dev.mi.com/console/doc/detail?pId=1822</a></p>
      <p>第三方公司名称：珠海市魅族通讯设备有限公司</p>
      <p>产品/类型：魅族消息推送服务sdk</p>
      <p>收集个人信息类型：设备标识信息（IMEI）、运营商信息、申请获取存储权限</p>
      <p>使用目的：用于向魅族手机用户推送消息</p>
      <p>收集方式：sdk本机采集</p>
      <p>使用场景：向用户推送消息时</p>
      <p>第三方隐私权政策链接：</p>
      <p><a href="https://www.meizu.com/legal.html">https://www.meizu.com/legal.html</a></p>
      <p>第三方公司名称：OPPO广东移动通信有限公司</p>
      <p>产品/类型：OPPO推送sdk</p>
      <p>收集个人信息类型：匿名用户ID（OAID）</p>
      <p>使用目的：用于向OPPO用户推送消息</p>
      <p>收集方式：sdk本机采集</p>
      <p>使用场景：向用户推送消息时</p>
      <p>第三方隐私权政策链接：</p>
      <p><a href="https://security.oppo.com/cn/privacy.html">https://security.oppo.com/cn/privacy.html</a></p>
      <p>第三方公司名称：维沃移动通信有限公司</p>
      <p>产品/类型：VIVO推送sdk</p>
      <p>收集个人信息类型：匿名用户ID（OAID）</p>
      <p>使用目的：用于向VIVO用户推送消息</p>
      <p>收集方式：sdk本机采集</p>
      <p>使用场景：向用户推送消息时</p>
      <p>功能：用于消息推送</p>
      <p>收集个人信息字段：匿名用户ID（OAID）</p>
      <p>第三方隐私权政策链接：</p>
      <p><a href="https://dev.vivo.com.cn/documentCenter/doc/366">https://dev.vivo.com.cn/documentCenter/doc/366</a></p>
      <p>第三方公司名称：深圳市腾讯计算机系统有限公司</p>
      <p>产品/类型：腾讯bugly</p>
      <p>收集个人信息类型：设备信息（IMEI/MAC/Android ID/IDFA/OpenUDID/GUID/IP地址/SIM卡IMSI信息/手机参数信息等）</p>
      <p>使用目的：云平台、企业协作、辅助运营</p>
      <p>收集方式：sdk本机采集</p>
      <p>功能：云平台、企业协作、辅助运营</p>
      <p>第三方隐私权政策链接：</p>
      <p><a
          href="https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56">https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56</a>
      </p>
      <p>第三方SDK名称：PictureSelector</p>
      <p>产品/类型：开源代码库</p>
      <p>使用目的：加载本地相册图片，拍照选择，收集外部存储文件和文件夹。</p>
      <p>功能：选择头像，选择文件上传</p>
      <p>链接：<a href="https://github.com/LuckSiege/PictureSelector">https://github.com/LuckSiege/PictureSelector</a></p>
      <p>第三方SDK名称：Network SDK</p>
      <p>收集个人信息类型：设备品牌、设备型号、设备版本、系统版本、手机样式、 手机名、MAC地址、IMSI、IMEI、IP地址、网络状态</p>
      <p>使用目的：网络数据请求，数据手机</p>
      <p>收集方式：sdk本机采集</p>
      <p>使用场景：登录，设备信息收集</p>
      <p>第三方SDK名称：com.umeng.analytics【友盟+移动统计】</p>
      <p>收集个人信息类型：设备品牌、设备型号、设备版本、系统版本、手机样式、 手机名、MAC地址、IMSI、IMEI、IP地址、网络状态</p>
      <p>使用目的：采集用户设备信息分析</p>
      <p>使用场景：设备信息收集</p>
      <p>第三方SDK名称：com.umeng.message【友盟+消息推送】</p>
      <p>收集个人信息类型：设备品牌、设备型号、设备版本、系统版本、手机样式、 手机名、MAC地址、IMSI、IMEI、IP地址、网络状态</p>
      <p>使用目的：推送消息给用户</p>
      <p>使用场景：考试报告信息推送给老师提醒老师查看</p>
      <p>第三方SDK名称：com.uc.crashsdk【Crash】</p>
      <p>收集个人信息类型：设备品牌、设备型号、设备版本、系统版本、手机样式、 手机名、MAC地址、IMSI、IMEI、IP地址、网络状态</p>
      <p>使用目的：提高稳定性，收集错误日志</p>
      <p>使用场景：用户APP报错时手机错误日志以供我们定位问题修复</p>
      <p>第三方SDK名称：com.umeng.umcrash【友盟+应用性能监控】</p>
      <p>收集个人信息类型：设备品牌、设备型号、设备版本、系统版本、手机样式、 手机名、MAC地址、IMSI、IMEI、IP地址、网络状态</p>
      <p>使用目的：提高稳定性，收集错误日志</p>
      <p>使用场景：用户APP报错时手机错误日志以供我们定位问题修复</p>
      <p>自启动和关联启动说明</p>
      <p>1、为确保本应用处于关闭或后台运行状态下可正常接收到客户端推送的信息，本应用须使用(自启动)能力，将存在一定频率通过 系统发送广播唤醒本应用自启动或关联启动行为，是因实现功能及服务所必要的。</p>
      <p>2、当您打开内容类推送消息，在征得您的明确同意后，会跳转打开相关内容。在未征得您同意的情况下，则不会有自启动或关联启动。</p>
      <p>3、当您打开本App内部下载的文件后，会关联启动第三方App。</p>
      <p>
        2、转让
      </p>
      <p>
        我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：
      </p>
      <p>
        事先获得您明确的同意或授权；
      </p>
      <p>
        根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况进行提供；
      </p>
      <p>
        符合与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；在涉及合并、收购、资产转让或类似的交易时，如涉及个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本隐私政策的约束，否则,我们将要求该公司、组织重新向您征求授权同意
      </p>
      <p>
        3、公开披露
      </p>
      <p>
        我们仅会在以下情况下，且采取符合法律和业界标准的安全防护措施的前提下，才会公开披露您的个人信息：
      </p>
      <p>
        根据您的需求，在您明确同意的披露方式下披露您所指定的个人信息；
      </p>
      <p>
        根据法律、法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式公开披露您的个人信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。我们对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。在法律法规许可的前提下，我们披露的文件均在加密密钥的保护之下。
      </p>
      <p>六、 关于未成年个人信息</p>
      <p>
        我们的产品主要面向成人，我们重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用我们的服务或产品前，应事先取得您的家长或法定监护人的同意并在他们的指导下使用。若您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问或拒绝进一步收集被监护人信息，或要求我们删除被监护人信息，请通过第十一条中的联系方式与我们联系。
      </p>
      <p>
        七、 如何管理您的个人信息
      </p>
      <p>
        我们将尽一切可能采取适当的技术手段，保证收集到的有关于您的个人信息的准确性，并保证及时进行更新。
      </p>
      <p>
        1、更正或补充您的个人信息
      </p>
      <p>
        除法律法规规定外，您有权随时访问和更正您的个人信息，具体包括：
      </p>
      <p>
        Web端路径：您可以在左上角点击头像，页面的“个人资料”菜单中查阅您提交给知心慧学教师端的所有个人信息，你也可通过上述途径更新除教师认证信息之外的其他个人信息（您的姓名、学科、手机号、岗位）。移动端具体路径为：
        “我的”进入我的知心慧学教师端--修改密码：您也可以通过「个人中心」-【意见反馈】页面，按照知心慧学教师端的相关政策及提示，或联系在线客服，对您的个人信息进行访问、更正。
      </p>
      <p class="bold">
        2、删除您的个人信息及注销账号
      </p>
      <p class="key-msg">
        您可以通过「我的」-【安全中心】页面，点击账号注销，填写账号及密码后申请注销，或联系在线客服，或拨打客服电话19970080755，我们将在2周内帮助您进行注销账号及删除有关信息的处理。 </p>
      <p>
      <p>
        3、消息管理推送
      </p>
      <p>
        对于您在使用服务的过程中提供的设备号，我们在运营过程中可能会向您的设备发送消息推送，用于用户消息告知、任务提醒等目的。在「个人中心」-【消息推送管理】页面，您可以选择是否接受定向推送信息，或选择接受部分情况下的推送通知。IOS系统用户可以在[系统设置]-[通知]-[知心慧学教师端]页面设置是否允许通知，安卓系统用户可在[系统设置]-[通知]-[知心慧学教师端]页面设置是否允许通知。
      </p>
      <p>
        八、我们会如何保护和保存您的个人信息
      </p>
      <p>
        知心慧学教师端重视个人信息的安全。我们采取互联网业内标准做法来保护您的个人信息，防止信息遭到未经授权访问、披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。
        我们会采取一切合理可行的措施，确保未收集与知心慧学教师端提供的服务无关的个人信息。我们会尽全力保护您的个人信息，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，不可能始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。我们仅允许有必要知晓这些信息的知心慧学教师端及知心慧学教师端关联方的员工、合作伙伴访问个人信息，并为此设置了严格的访问权限控制和监控机制。我们同时要求可能接触到您个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与知心慧学教师端的合作关系。我们同时要求可能接触到您个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与知心慧学教师端的合作关系。在发生个人信息安全事件的场合，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。我们在中华人民共和国境内收集和产生的个人信息将存储在中华人民共和国境内。如果日后为处理跨境业务，需要向境外机构传输境内收集的相关个人信息的，我们会事先征得您的同意，按照法律、行政法规和相关监管部门的规定执行，并通过签订协议、核查等有效措施，要求境外机构为所获得的个人信息保密。我们仅会在达到本政策所述目的所必需的时限内保存您的个人信息，但为了遵守适用的法律法规、法院判决或裁定、其他有权机关的要求、维护公共利益等目的，我们可能会将个人信息保存时间予以适当延长。
      </p>
      <p>
        九、 第三方提供商及其服务
      </p>
      <p>
        为确保流畅的浏览体验，您可能会收到来自知心慧学教师端及其合作伙伴外部的第三方（以下简称「第三方」）提供的内容或网络链接。知心慧学教师端对此类第三方无控制权。您可选择是否访问第三方提供的链接、内容、产品和服务。知心慧学教师端无法控制第三方的隐私和个人信息保护政策，此类第三方不受到本政策的约束。您在向第三方提交个人信息之前，请确保您阅读并认可这些第三方的隐私保护政策。
      </p>
      <p>
        十、本政策如何更新及适用范围
      </p>
      <p>
        为给用户提供更好的服务，知心慧学教师端的业务将不时变化，本隐私政策也将随之调整。知心慧学教师端会通过在知心慧学教师端网站、移动端上发出更新版本并提醒您相关内容的更新，也请您访问知心慧学教师端以便及时了解最新的隐私政策。知心慧学教师端保留不时更新或修改本政策的权利。如果该等修改造成您在本政策下权利的实质减少，知心慧学教师端会通过不同渠道向您发送变更通知，包括但不限于网站公示、短信、邮件通知等方式。
        若您不同意修改后的隐私政策，您有权并应立即停止使用知心慧学教师端的服务。如果您继续使用知心慧学教师端的服务，则视为您接受知心慧学教师端对本政策相关条款所做的修改。
      </p>
      <p>
        知心慧学教师端的所有服务均适用本政策。但某些服务有其特定的隐私政策，该等特定的隐私政策更具体地说明知心慧学教师端在该服务中如何处理您的信息。如本政策与特定服务的隐私政策有不一致之处，请以该特定隐私政策为准。
      </p>
      <p>
        十一、联系我们
      </p>
      <p>您在使用知心慧学教师端的过程中对本隐私政策或对您个人信息有任何问题、建议、意见及咨询，请通过以下联系方式与我们联系：</p>
      <p>联系电话<span class="blue">19970080755</span></p>
      <p>邮箱 <span class="blue">legal@fxbjy.com</span></p>
      <p>如您有相关申诉问题，也可通过上方联系方式与我们联系。若您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，在您向我们反馈后我们无法提供让您满意的回复且拒绝改进的，您可以向相关监管机构进行投诉和举报。
      </p>

  </div>
</template>
<script>
export default {
  methods: {
    clickPrivacy(type) {
      // btnType 1《用户服务协议》2《隐私政策》
      let msg = { btnType: type };
      let u = navigator.userAgent;
      let isAndroid = u.includes('Android') || u.includes('Adr'); //android终端
      let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid && window.injectedObject) {
        console.log('an')
        window.injectedObject.sendClickEventPrivacy(type)
      } else if (isiOS && window.webkit) {
        console.log('ios')
        window.webkit.messageHandlers.sendClickEventPrivacy.postMessage(msg)
      }
    }
  }
}
</script>
<style scoped>
@import url('../../assets/css/service.css');
</style>



// WEBPACK FOOTER //
// TeacherPrivacy2.vue?85f48348